import {
    api_patchAppointment,
    api_putOwnerReview,
    api_putProviderReview,
    api_setAppointmentNotes,
    api_patchAppointmentNotes,
    api_getAppointmentNotes,
    api_getAppointmentNoteByID,
    api_getPrescriptions,
    api_patchPrescriptionByID,
    api_deletePrescriptionByID,
    api_addNewPrescription,
    api_getAppointmentByID,
    api_getFollowUpByID,
    api_patchFollowUp,
    api_postFollowUp
} from "./appointment.api";
import {
    setAppointment,
    setReview,
    setNotes,
    setPrescriptions,
    deletePrescription
} from "./appointment.reducers";

export const setOwnerReview = params => dispatch => (
    api_putOwnerReview(params).then(res => {
        dispatch(setReview(res));
    })
);

export const setProviderReview = params => dispatch => (
    api_putProviderReview(params).then(res => {
        dispatch(setReview(res));
    })
);

export const getAppointmentNotes = params => dispatch => (
    api_getAppointmentNotes(params).then(res => {
        dispatch(setNotes(res));
        return res;
    })
);

export const getAppointmentNoteByID = id => dispatch => (
    api_getAppointmentNoteByID(id).then(res => {
        return res;
    })
);

export const getFollowUpByID = id => dispatch => (
    api_getFollowUpByID(id).then(res => {
        return res;
    })
);

export const patchFollowUps = (body, id) => dispatch => (
    api_patchFollowUp(body, id).then(res => {
        return res;
    })
);

export const postFollowUps = (body) => dispatch => (
    api_postFollowUp(body).then(res => {
        return res;
    })
);

export const setAppointmentNotes = params => dispatch => (
    api_setAppointmentNotes(params).then(res => {
        return res;
    })
);

export const patchAppointmentNotes = (id, body) => dispatch => (
    api_patchAppointmentNotes(id, body).then(res => {
        return res;
    })
);

export const patchAppointment = (id, body) => dispatch => (
    api_patchAppointment(id, body).then(res => {
        dispatch(setAppointment(res));
        return res;
    })
);

export const setSelectedAppointment = appointment => dispatch => (
    dispatch(setAppointment(appointment))
);

export const getPrescriptions = id => dispatch => (
    api_getPrescriptions(id).then(res => {
        dispatch(setPrescriptions(res));
        return res;
    })
);

export const setPrescriptionList = list => dispatch => (
    dispatch(setPrescriptions(list))
);

export const addNewPrescription = body => dispatch => (
    api_addNewPrescription(body).then(res => {
        return res;
    })
);

export const patchPrescriptionByID = (id, body) => dispatch => (
    api_patchPrescriptionByID(id, body).then(res => {
        return res;
    })
);

export const deletePrescriptionByID = id => dispatch => (
    api_deletePrescriptionByID(id).then(res => {
        dispatch(deletePrescription(res));
        return res;
    })
);

export const removePrescription = item => dispatch => (
    dispatch(deletePrescription(item))
);

export const getAppointment = id => (
    api_getAppointmentByID(id).then(res => {
        return res;
    })
);

